var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useResponsiveProps, } from '@core-front/helper';
import { useTheme } from '@core-front/theme-provider';
const TagCore = (props) => {
    const { responsive } = props, rest = __rest(props, ["responsive"]);
    return responsive ? React.createElement(TagResponsiveCore, Object.assign({}, rest, { responsive: responsive })) : React.createElement(TagInnerCore, Object.assign({}, rest));
};
const TagResponsiveCore = (props) => {
    const { responsive } = props, rest = __rest(props, ["responsive"]);
    const { breakPoints } = useTheme();
    const responsiveProps = useResponsiveProps({ breakPoints, responsive });
    return React.createElement(TagInnerCore, Object.assign({}, rest, responsiveProps));
};
const tagSizeFontSize = {
    tiny: 'small',
    small: 'large',
    medium: 'extra-large',
    large: 'small',
};
class TagInnerCore extends React.Component {
    constructor(props) {
        super(props);
        this.fadeDuration = 300;
        this.interval = 0;
        /**
         * Called after every animationDuration
         * Sets animationState and animated content index
         */
        this.updateState = () => {
            if (!this.props.content) {
                return;
            }
            this.setState({
                animationState: 'fade-out',
            }, () => setTimeout(() => {
                let nextIndex = this.state.currentIndex + 1;
                if (this.props.content && nextIndex === this.props.content.length) {
                    nextIndex = 0;
                }
                this.setState({
                    animationState: 'fade-in',
                    currentIndex: nextIndex,
                }, () => setTimeout(() => {
                    this.setState({
                        animationState: 'faded-in',
                    });
                }, this.fadeDuration));
            }, this.fadeDuration));
        };
        this.state = {
            animationState: 'faded-in',
            currentIndex: 0,
        };
    }
    componentDidMount() {
        if (this.props.content && this.props.content.length > 1 && this.props.size !== 'tiny') {
            this.interval = window.setInterval(this.updateState, (this.props.animationDuration || 3000) - this.fadeDuration);
        }
    }
    componentWillUnmount() {
        if (this.props.content) {
            window.clearInterval(this.interval);
        }
    }
    BEM() {
        const { size } = this.props;
        const classArray = ['tag', `tag--${size}`];
        if (this.props.purpose) {
            classArray.push(`tag--${this.props.purpose}`);
        }
        if (this.props.icon && !this.props.content) {
            classArray.push('tag--icon');
        }
        if (this.props.image && !this.props.content) {
            classArray.push('tag--image');
        }
        if (this.props.content) {
            classArray.push('tag--animating');
        }
        if (this.props.isDisabled) {
            classArray.push('tag--disabled');
        }
        if (this.props.tooltip) {
            classArray.push('tag--tooltip');
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    contentBEM(item) {
        const classArray = ['tag__content'];
        if (this.props.content && this.props.size !== 'tiny') {
            const index = this.props.content.findIndex((i) => item === i);
            if (this.state.currentIndex === index) {
                classArray.push(`tag__content--${this.state.animationState}`);
            }
        }
        return classArray.join(' ');
    }
    renderIcon(icon) {
        const { Icon } = this.props.components;
        return React.createElement(Icon, { className: "tag__icon", modifiers: icon });
    }
    renderText(item) {
        const { Fittext } = this.props.components;
        const classArray = ['tag__text'];
        const { size } = this.props;
        if (item.image || (item.icon && this.props.size !== 'large' && this.props.size !== 'tiny')) {
            classArray.push('tag__text--hidden');
        }
        if (item.fontSize) {
            classArray.push('tag__text--' + item.fontSize);
        }
        else if (this.props.tagSizeFontSizeProp) {
            classArray.push('tag__text--' + this.props.tagSizeFontSizeProp[size]);
        }
        else if (tagSizeFontSize[size]) {
            classArray.push('tag__text--' + tagSizeFontSize[size]);
        }
        let tagTextContent;
        if (typeof item.text === 'string') {
            tagTextContent = React.createElement(Fittext, null, item.text);
        }
        else {
            tagTextContent = item.text;
        }
        return (React.createElement("span", { className: classArray.join(' ') }, this.props.renderContent ? this.props.renderContent : tagTextContent));
    }
    renderImage(image) {
        const { Image } = this.props.components;
        return (React.createElement(Image, Object.assign({}, image, { className: "tag__image" })));
    }
    renderContent(item, key) {
        const ContentElement = this.props.tooltip ? 'span' : 'div';
        return (React.createElement(ContentElement, { className: this.contentBEM(item), key: key },
            item.icon && this.props.size !== 'tiny' && this.renderIcon(item.icon),
            item.text && !this.props.renderContent && this.renderText(item),
            item.image && this.renderImage(item.image),
            this.props.text && this.props.renderContent && this.renderText(item)));
    }
    renderMultipleContent(content) {
        return content.map((item, key) => this.renderContent(item, key));
    }
    renderToolTipWrapper(defaultItem, tooltip) {
        const { id } = tooltip, tooltipProps = __rest(tooltip, ["id"]);
        const { Tooltip } = this.props.components;
        return (React.createElement(React.Fragment, null,
            React.createElement("button", { type: "button", id: id, className: this.BEM() }, this.props.content ? this.renderMultipleContent(this.props.content) : this.renderContent(defaultItem)),
            React.createElement(Tooltip, Object.assign({ referenceElement: `#${id}` }, tooltipProps))));
    }
    renderDefaultWrapper(defaultItem) {
        return (React.createElement("div", { className: this.BEM() }, this.props.content ? this.renderMultipleContent(this.props.content) : this.renderContent(defaultItem)));
    }
    render() {
        const defaultItem = {
            fontSize: this.props.fontSize,
            icon: this.props.icon,
            image: this.props.image,
            text: this.props.text,
        };
        const { tooltip } = this.props;
        return tooltip ? this.renderToolTipWrapper(defaultItem, tooltip) : this.renderDefaultWrapper(defaultItem);
    }
}
TagInnerCore.defaultProps = {
    animationDuration: 3000,
    size: 'large',
};
export default TagCore;
